/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListSalePointDto } from '../models/api-response-list-sale-point-dto';
import { ApiResponseSalePointDto } from '../models/api-response-sale-point-dto';
import { ApiResponseSalePointMenuDto } from '../models/api-response-sale-point-menu-dto';
import { archiveSalePoint } from '../fn/sale-point-api/archive-sale-point';
import { ArchiveSalePoint$Params } from '../fn/sale-point-api/archive-sale-point';
import { createSalePoint } from '../fn/sale-point-api/create-sale-point';
import { CreateSalePoint$Params } from '../fn/sale-point-api/create-sale-point';
import { getSalePointByReference } from '../fn/sale-point-api/get-sale-point-by-reference';
import { GetSalePointByReference$Params } from '../fn/sale-point-api/get-sale-point-by-reference';
import { getSalePointMenu } from '../fn/sale-point-api/get-sale-point-menu';
import { GetSalePointMenu$Params } from '../fn/sale-point-api/get-sale-point-menu';
import { getSalePoints } from '../fn/sale-point-api/get-sale-points';
import { GetSalePoints$Params } from '../fn/sale-point-api/get-sale-points';
import { updateSalePoint } from '../fn/sale-point-api/update-sale-point';
import { UpdateSalePoint$Params } from '../fn/sale-point-api/update-sale-point';
import { updateSalePointMenu } from '../fn/sale-point-api/update-sale-point-menu';
import { UpdateSalePointMenu$Params } from '../fn/sale-point-api/update-sale-point-menu';

@Injectable({ providedIn: 'root' })
export class SalePointApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getSalePoints()` */
  static readonly GetSalePointsPath = '/v1/api/sale-points/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSalePoints()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalePoints$Response(params: GetSalePoints$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListSalePointDto>> {
    return getSalePoints(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSalePoints$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalePoints(params: GetSalePoints$Params, context?: HttpContext): Observable<ApiResponseListSalePointDto> {
    return this.getSalePoints$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListSalePointDto>): ApiResponseListSalePointDto => r.body)
    );
  }

  /** Path part for operation `createSalePoint()` */
  static readonly CreateSalePointPath = '/v1/api/sale-points';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSalePoint()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSalePoint$Response(params: CreateSalePoint$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSalePointDto>> {
    return createSalePoint(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSalePoint$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSalePoint(params: CreateSalePoint$Params, context?: HttpContext): Observable<ApiResponseSalePointDto> {
    return this.createSalePoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseSalePointDto>): ApiResponseSalePointDto => r.body)
    );
  }

  /** Path part for operation `getSalePointByReference()` */
  static readonly GetSalePointByReferencePath = '/v1/api/sale-points/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSalePointByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalePointByReference$Response(params: GetSalePointByReference$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSalePointDto>> {
    return getSalePointByReference(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSalePointByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalePointByReference(params: GetSalePointByReference$Params, context?: HttpContext): Observable<ApiResponseSalePointDto> {
    return this.getSalePointByReference$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseSalePointDto>): ApiResponseSalePointDto => r.body)
    );
  }

  /** Path part for operation `updateSalePoint()` */
  static readonly UpdateSalePointPath = '/v1/api/sale-points/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSalePoint()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSalePoint$Response(params: UpdateSalePoint$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSalePointDto>> {
    return updateSalePoint(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSalePoint$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSalePoint(params: UpdateSalePoint$Params, context?: HttpContext): Observable<ApiResponseSalePointDto> {
    return this.updateSalePoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseSalePointDto>): ApiResponseSalePointDto => r.body)
    );
  }

  /** Path part for operation `archiveSalePoint()` */
  static readonly ArchiveSalePointPath = '/v1/api/sale-points/archive/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `archiveSalePoint()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveSalePoint$Response(params: ArchiveSalePoint$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSalePointDto>> {
    return archiveSalePoint(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `archiveSalePoint$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  archiveSalePoint(params: ArchiveSalePoint$Params, context?: HttpContext): Observable<ApiResponseSalePointDto> {
    return this.archiveSalePoint$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseSalePointDto>): ApiResponseSalePointDto => r.body)
    );
  }

  /** Path part for operation `getSalePointMenu()` */
  static readonly GetSalePointMenuPath = '/v1/api/sale-points/{reference}/menu';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSalePointMenu()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalePointMenu$Response(params: GetSalePointMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSalePointMenuDto>> {
    return getSalePointMenu(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSalePointMenu$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalePointMenu(params: GetSalePointMenu$Params, context?: HttpContext): Observable<ApiResponseSalePointMenuDto> {
    return this.getSalePointMenu$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseSalePointMenuDto>): ApiResponseSalePointMenuDto => r.body)
    );
  }

  /** Path part for operation `updateSalePointMenu()` */
  static readonly UpdateSalePointMenuPath = '/v1/api/sale-points/{reference}/menu';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSalePointMenu()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSalePointMenu$Response(params: UpdateSalePointMenu$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseSalePointMenuDto>> {
    return updateSalePointMenu(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSalePointMenu$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSalePointMenu(params: UpdateSalePointMenu$Params, context?: HttpContext): Observable<ApiResponseSalePointMenuDto> {
    return this.updateSalePointMenu$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseSalePointMenuDto>): ApiResponseSalePointMenuDto => r.body)
    );
  }

}
